import React from 'react';
import { FadeIn } from './FadeIn';
import { GiftIcon, ZapIcon, CalendarDaysIcon, MessageCircleWarningIcon, MessageSquareHeartIcon, ClipboardCheckIcon, BatteryChargingIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: <ZapIcon className="w-6 h-6" data-id="element-16" />,
    title: 'El Arranque Express de 7 Días',
    desc: 'Para que no te quedes paralizado ante 420 páginas. Un plan día por día para tener todo funcionando en una semana real.'
  }, {
    icon: <CalendarDaysIcon className="w-6 h-6" data-id="element-17" />,
    title: 'Los 52 Anclajes Semanales',
    desc: 'Para que nunca más te preguntes qué trabajar esta semana. Un tema potente para cada semana del año, con variantes por nivel y consignas listas.'
  }, {
    icon: <MessageCircleWarningIcon className="w-6 h-6" data-id="element-18" />,
    title: 'Respuestas Rápidas para Clases Difíciles',
    desc: 'Para que la lluvia, el alumno frustrado, el grupo sin energía o la pista ocupada dejen de ser problemas sin solución. Protocolos exactos para 20 situaciones reales.'
  }, {
    icon: <MessageSquareHeartIcon className="w-6 h-6" data-id="element-19" />,
    title: 'El Pack de Feedback que Fideliza',
    desc: 'Para que cada clase deje algo tangible en las manos del alumno. Las palabras exactas. Los momentos exactos. El sistema que convierte el feedback en retención.'
  }, {
    icon: <ClipboardCheckIcon className="w-6 h-6" data-id="element-20" />,
    title: 'Las Checklists de Pista',
    desc: 'Para que nunca más llegués a pista sin material, sin plan o con la cabeza llena de micro-pendientes. El sistema completo en tarjetas de bolsillo imprimibles.'
  }, {
    icon: <BatteryChargingIcon className="w-6 h-6" data-id="element-21" />,
    title: 'La Guía de Clases con Más Energía',
    desc: 'Para que tus clases se sientan diferentes desde el primer minuto. Los 6 activadores, las transiciones que no cortan el ritmo y los cierres que hacen que el alumno quiera volver.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-padel-surface" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <FadeIn data-id="element-24">
          <div className="text-center mb-16" data-id="element-25">
            <div className="inline-flex items-center justify-center gap-2 bg-padel-lime/10 text-padel-lime px-4 py-2 rounded-full font-bold mb-6" data-id="element-26">
              <GiftIcon className="w-5 h-5" data-id="element-27" />
              <span data-id="element-28">6 BONOS EXCLUSIVOS</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-display font-bold text-white max-w-3xl mx-auto" data-id="element-29">
              Y además de los 6 tomos, recibís 6 bonos que resuelven lo que el
              sistema base no puede cubrir solo.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-30">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-31">
              <div className="bg-padel-dark border border-padel-muted p-6 sm:p-8 rounded-2xl h-full flex flex-col" data-id="element-32">
                <div className="bg-padel-surface w-12 h-12 rounded-full flex items-center justify-center text-padel-lime mb-6 border border-padel-muted" data-id="element-33">
                  {bonus.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-3" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-35">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}